import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Droppable, DragDropContext } from "react-beautiful-dnd";

import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";

import { red } from "@material-ui/core/colors";
import { DeleteSweep } from "@material-ui/icons";

import { AutorizacionesDocumentacionTarjeta } from "../../Ingreso/AutorizacionesDocumentacionTarjeta";
import AlertDialogSlide from "../../../ui/AlertaConfirm";

import { startAlerta } from "../../../../actions/ui/alertas";
import {
  deleteDocumentacionPresupuesto, getDocumentacionPresupuesto, getTiposDocumentacionPresupuesto,
} from "../../../../actions/autorizaciones/Autorizaciones";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  title: {
    fontSize: 12,
  },
  iconoTrash: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    color: "#fff",
    backgroundColor: red[500],
    marginLeft: "auto",
    marginRight: "auto",
  },
  contenedorTrash: {
    height: 170,
    textAlign: "center",
    marginTop: "auto",
    marginBottom: "auto",
  },
  tarjetaReadOnly: {
    pointerEvents: "none",
    opacity: 0.4,
  },
}));

export const InformacionDocumentacionPresupuesto = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const baseUrl = process.env.REACT_APP_URL;

  const [open, setOpen] = useState(false);
  const [idDocumentoPresupuesto, setIdDocumentoPresupuesto] = useState(0);
  const [idTipoDoc, setIdTipoDoc] = useState(0);

  const {
    documentacion,
    presupuestoSeleccionado = {},
    tiposDocumentacionPresupuesto: tiposDocumentacion,
  } = useSelector((state) => state.autorizaciones);

  let idPresupuesto = null;

  if (presupuestoSeleccionado) {
    idPresupuesto = presupuestoSeleccionado.idPresupuesto;
  }

  let arrayURLs = [];
  let documentacionCopy = [...documentacion];
  let tiposDocumentacionCopy = [...tiposDocumentacion];

  if (documentacion?.length > 0) {
    for (var j = 0; j < tiposDocumentacionCopy.length; j++) {
      for (var i = 0; i < documentacionCopy.length; i++) {
        if (
          tiposDocumentacionCopy[j].idTipoDoc === documentacionCopy[i].idTipoDoc
        ) {
          let obj = {};
          obj.url =
            baseUrl +
            "/" +
            documentacionCopy[i].urlCarpeta +
            documentacionCopy[i].nombreDocumento;
          obj.id = `${documentacionCopy[i].idDocumentacionPresupuesto},idTipoDoc=${documentacionCopy[i].idTipoDoc}`;
          arrayURLs.push(obj);
        }
      }
      tiposDocumentacionCopy[j].URLs = arrayURLs;
      arrayURLs = [];
    }
  } else {
    arrayURLs = [];
    tiposDocumentacion.forEach((url) => {
      url.URLs = [];
    });
    documentacionCopy = [];
  }

  const deleteModalHandler = (confirm) => {
    if (confirm === "SI") {
      const esDocumentoObligatorio = tiposDocumentacionCopy.find(
        (tipoDocumento) => tipoDocumento.idTipoDoc === idTipoDoc
      )?.obligatorio;
      if (!esDocumentoObligatorio) {
        dispatch(deleteDocumentacionPresupuesto(idPresupuesto, idDocumentoPresupuesto));
      } else {
        dispatch(
          startAlerta(
            `No se puede borrar documentación obligatoria.`,
            "error",
            "Error"
          )
        );
      }
    }
    setOpen(false);
  };

  const handleOnDragEnd = (result) => {
    if(!props.disabled){
      const { destination } = result;

      if (!destination) {
        return;
      }

      const idDocumentacionPresupuesto = parseInt(
        result.draggableId.replace("documentacion", "")
      );
      const idTipoDoc = parseInt(result.draggableId.split(",")[1]?.split("=")[1]);

      if (destination.droppableId === "eliminardoc") {
        setIdDocumentoPresupuesto(idDocumentacionPresupuesto);
        setIdTipoDoc(idTipoDoc);
        setOpen(true);
      }
    }else{
      dispatch(
        startAlerta(
          `No se puede mover la documentación cuando la Presupuesto esta Finalizada.`,
          "error",
          "Error"
        )
      );
    }
  };

  useEffect(() => {
    dispatch(getTiposDocumentacionPresupuesto());
    if (idPresupuesto) dispatch(getDocumentacionPresupuesto(idPresupuesto));
  }, [idPresupuesto]);

  useEffect(() => {
    props.setFaltaDocumentacion(false);
    for (let tipoDoc of tiposDocumentacion) {
      if (tipoDoc.obligatorio) {
        const documentosPorTipo = documentacion.filter(
          (doc) => doc.idTipoDoc === tipoDoc.idTipoDoc
        );
        if (documentosPorTipo.length === 0) {
          props.setFaltaDocumentacion(true);
          return;
        }
      }
    }
  }, [documentacion, tiposDocumentacion]);

  return (
    <React.Fragment>
      <div style={{ marginTop: "2rem" }}>
        <Typography variant="h6" style={{ marginBottom: "1.5rem" }}>
          Documentación
        </Typography>
        <AlertDialogSlide
          open={open}
          setOpen={setOpen}
          mensaje="Está seguro que desea eliminar la imagen?"
          handleDecision={deleteModalHandler}
        />
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={10}>
              <Grid container spacing={1} direction="row" alignItems="center">
                {tiposDocumentacionCopy?.map((item, index) => (
                  <Droppable
                    key={item.idTipoDoc}
                    droppableId={`idTipoDoc${item.idDocumentacionPresupuesto}`}
                  >
                    {(provided) => (
                      <Grid
                        key={item.idTipoDoc}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        item
                        style={{ alignSelf: "start" }}
                      >
                        <AutorizacionesDocumentacionTarjeta
                          idTipoSolicitud={presupuestoSeleccionado.idTipoSolicitud}
                          idPresupuesto={idPresupuesto}
                          item={item}
                          key={index}
                          titulo={`${item.tipoDocumentacion?.descripcion}`}
                          idTipoDoc={item.idTipoDoc}
                          urls={item.URLs}
                          disabled={/*props.disabled*/ false}
                        />
                        {provided.placeholder}
                      </Grid>
                    )}
                  </Droppable>
                ))}
              </Grid>
            </Grid>
            {true && !props.disabled && (
              <Grid item xs={12} sm={2}>
                <Droppable droppableId="eliminardoc">
                  {(provided) => (
                    <Card elevation={3}>
                      <CardActionArea>
                        <CardContent>
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className={classes.contenedorTrash}
                          >
                            <Grid
                              container
                              justify="center"
                              alignItems="center"
                              style={{ height: "100%" }}
                            >
                              <Grid item>
                                <Typography
                                  className={classes.title}
                                  color="textSecondary"
                                  gutterBottom
                                >
                                  Arrastre aquí para eliminar
                                </Typography>
                                <HtmlTooltip
                                  title={
                                    <>
                                      <em>
                                        {"Eliminar"}
                                        <b>{" documento"}</b>
                                      </em>
                                      <br></br>
                                      {"Arrastre "} <u>{"aquí"}</u>{" "}
                                      {" para eliminar"}
                                    </>
                                  }
                                >
                                  <Avatar className={classes.iconoTrash}>
                                    <DeleteSweep style={{ fontSize: "2rem" }} />
                                  </Avatar>
                                </HtmlTooltip>
                                {provided.placeholder}
                              </Grid>
                            </Grid>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  )}
                </Droppable>
              </Grid>
            )}
          </Grid>
        </DragDropContext>
      </div>
    </React.Fragment>
  );
};
